import React, { useEffect, useState } from 'react';
import { Folder, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useApi } from './DashboardLayout';

export default function ManagerDocumentsPage() {
  const { apiFetch } = useApi();
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/providers/managed').then(r => r?.json()).then(d => {
      if (Array.isArray(d)) setProviders(d);
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>Laden...</div>;

  return (
    <div data-testid="manager-documents-page">
      <div className="page-header">
        <h2>Dokumente</h2>
        <p>Dokumente Ihrer verwalteten Standorte</p>
      </div>

      {providers.length === 0 ? (
        <div className="of-card" style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
          <p>Keine Standorte zugewiesen.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
          {providers.map(p => (
            <Link key={p.id} to={`/app/provider-documents/${p.id}`}
              style={{ textDecoration: 'none', color: 'inherit' }}
              data-testid={`doc-folder-${p.id}`}>
              <div className="of-card" style={{ padding: '16px 20px', cursor: 'pointer', transition: 'border-color 0.2s, box-shadow 0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(204,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Folder size={20} style={{ color: 'var(--primary)' }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{p.verein || 'Unbekannt'}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                      {p.city_location || ''} {p.club_id ? `· Club-ID: ${p.club_id}` : ''}
                    </div>
                  </div>
                  <ArrowRight size={16} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
